<div class="section-title">
    {{ 'mimic.settings.gauge.name.title' | translate }}
</div>
<div class="dropdown-group">
    <app-channel-text-input
        name="gaugeTitle"
        label="mimic.settings.gauge.title"
        [value]="title"
        [dark]="true"
        (onInputChange)="handleTitleChange($event)"
        (onFocusChange)="handleTitleBlur($event)"></app-channel-text-input>
    <app-channel-select-input
        name="gaugeTitlePosition"
        label="mimic.settings.gauge.title-position"
        [value]="titlePositionKey"
        [itemList]="TitlePositionOptions"
        [dark]="true"
        (inputChange)="handleTitlePositionChange($event)"></app-channel-select-input>
</div>

<div class="section-title">
    {{ 'mimic.settings.valve-object.appearance.title' | translate }}
</div>
<div class="dropdown-group">
    <app-channel-select-input
        name="gaugeType"
        label="mimic.settings.gauge.type"
        [value]="AppearanceTypeOptions[0]"
        [itemList]="AppearanceTypeOptions"
        [dark]="true"
        [isDisabled]="true"></app-channel-select-input>

    <div class="option">
        <div>
            {{ 'mimic.settings.bar.units.toggle' | translate }}
        </div>
        <div class="option-toggle">
            <div>
                <ng-container *ngIf="!displayUnits">
                    {{ 'dlg.disabled' | translate }}
                </ng-container>
                <ng-container *ngIf="displayUnits">
                    {{ 'dlg.enabled' | translate }}
                </ng-container>
            </div>
            <mat-slide-toggle class="toggle" [checked]="displayUnits" (change)="handleUnitDisplayChange($event)">
            </mat-slide-toggle>
        </div>
    </div>

    <div class="option">
        <div>
            {{ 'mimic.settings.bar.value.toggle' | translate }}
        </div>
        <div class="option-toggle">
            <div>
                <ng-container *ngIf="!displayValue">
                    {{ 'dlg.disabled' | translate }}
                </ng-container>
                <ng-container *ngIf="displayValue">
                    {{ 'dlg.enabled' | translate }}
                </ng-container>
            </div>
            <mat-slide-toggle class="toggle" [checked]="displayValue" (change)="handleValueDisplayChange($event)">
            </mat-slide-toggle>
        </div>
    </div>

    <div class="option">
        <div>
            {{ 'mimic.settings.bar.name.toggle' | translate }}
        </div>
        <div class="option-toggle">
            <div>
                <ng-container *ngIf="!displayName">
                    {{ 'dlg.disabled' | translate }}
                </ng-container>
                <ng-container *ngIf="displayName">
                    {{ 'dlg.enabled' | translate }}
                </ng-container>
            </div>
            <mat-slide-toggle class="toggle" [checked]="displayName" (change)="handleNameDisplayChange($event)">
            </mat-slide-toggle>
        </div>
    </div>
</div>

<ng-container *ngIf="assignedChannel">
    <div class="section-header">
        <div class="section-title">
            {{ 'mimic.settings.gauge.scale.title' | translate }}
        </div>
        <div class="link-button" (click)="openChannels()">
            {{ 'mimic.settings.gauge.edit-channels' | translate }}
        </div>
    </div>
    <div class="dropdown-group">
        <app-channel-select-input
            name="gaugeDivisions"
            label="mimic.settings.gauge.divisions"
            [value]="selectedDivision"
            [itemList]="divisionOptions"
            [dark]="true"
            (inputChange)="handleDivisionsChange($event)"></app-channel-select-input>
    </div>
    <div class="custom-divisions-container">
        <div class="link-button" (click)="openCustomDivisionsDialog()">
            {{
                isCustomDivisions
                    ? ('mimic.settings.gauge.custom-divisions.edit' | translate)
                    : ('mimic.settings.gauge.custom-divisions.add' | translate)
            }}
        </div>
    </div>
</ng-container>
